// import React, { useState, useEffect } from 'react';
// import { Search, Calendar, FileText, Plus, X, Loader2, Edit3, Trash2, Link, Award } from 'lucide-react';

// export default function ExamProjectUpdates() {
//   const [activeTab, setActiveTab] = useState('exams'); // exams, projects
//   const [dataList, setDataList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [tableLoading, setTableLoading] = useState(false);

//   // Modal Control Triggers
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingId, setEditingId] = useState(null);


//   const [coursesList, setCoursesList] = useState([]); // ➕ Dynamic Courses State


//   // ➕ ADDED: Pagination Control Parameters
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   // Form State Containers
//   const [examForm, setExamForm] = useState({ target_course: 'React FullStack', academic_year: '2026-2027', current_semester: 'Semester 1', subject_code: '', subject_name: '', exam_date: '', exam_time: '', assessment_type: 'End-Semester Exam (ESE)', exam_mode: 'Online Portal' });
//   const [projectForm, setProjectForm] = useState({ target_course: 'React FullStack', academic_year: '2026-2027', current_semester: 'Semester 1', project_title: '', problem_statement: '', submission_deadline: '', reference_link: '', max_marks: '100' });

//   useEffect(() => {
//     fetchUpdates();
//   }, [activeTab, searchTerm]);


//   // ➕ Fetch dynamic courses from API
// useEffect(() => {
//   const fetchCoursesList = async () => {
//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
//       const data = await res.json();
//       if (data.success && data.data.length > 0) {
//         setCoursesList(data.data);
//         // Set default target_course for forms to first API course
//         const firstCourse = data.data[0].course_name.trim();
//         setExamForm((prev) => ({ ...prev, target_course: firstCourse }));
//         setProjectForm((prev) => ({ ...prev, target_course: firstCourse }));
//       }
//     } catch (err) {
//       console.error("Failed to load course options:", err);
//     }
//   };
//   fetchCoursesList();
// }, []);

//   const fetchUpdates = async () => {
//     setTableLoading(true);
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
//       const result = await res.json();
//       if (result.success) setDataList(result.data);
//       else setDataList([]);
//     } catch (err) {
//       console.error(err);
//       setDataList([]);
//     } finally { setTableLoading(false); }
//   };

//   // const handleOpenAddModal = () => {
//   //   setEditingId(null);
//   //   setExamForm({ target_course: 'React FullStack', academic_year: '2026-2027', current_semester: 'Semester 1', subject_code: '', subject_name: '', exam_date: '', exam_time: '', assessment_type: 'End-Semester Exam (ESE)', exam_mode: 'Online Portal' });
//   //   setProjectForm({ target_course: 'React FullStack', academic_year: '2026-2027', current_semester: 'Semester 1', project_title: '', problem_statement: '', submission_deadline: '', reference_link: '', max_marks: '100' });
//   //   setIsModalOpen(true);
//   // };


//   const handleOpenAddModal = () => {
//   setEditingId(null);
//   const defaultCourse = coursesList[0]?.course_name.trim() || '';
//   setExamForm({ target_course: defaultCourse, academic_year: '2026-2027', current_semester: 'Semester 1', subject_code: '', subject_name: '', exam_date: '', exam_time: '', assessment_type: 'End-Semester Exam (ESE)', exam_mode: 'Online Portal' });
//   setProjectForm({ target_course: defaultCourse, academic_year: '2026-2027', current_semester: 'Semester 1', project_title: '', problem_statement: '', submission_deadline: '', reference_link: '', max_marks: '100' });
//   setIsModalOpen(true);
// };

//   const handleOpenEditModal = (item) => {
//     setEditingId(item.id);
//     if (activeTab === 'exams') {
//       // Parse database standard SQL timestamp strings cleanly back into standard form inputs YYYY-MM-DD
//       const formattedDate = item.exam_date ? item.exam_date.substring(0, 10) : '';
//       setExamForm({ ...item, exam_date: formattedDate });
//     } else {
//       const formattedDeadline = item.submission_deadline ? item.submission_deadline.substring(0, 10) : '';
//       setProjectForm({ ...item, submission_deadline: formattedDeadline });
//     }
//     setIsModalOpen(true);
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const payload = activeTab === 'exams' ? examForm : projectForm;
//     const endpoint = editingId ? `update-entry/${editingId}` : 'add-entry';
//     const method = editingId ? 'PUT' : 'POST';

//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates/${endpoint}`, {
//         method: method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ targetTab: activeTab, payload })
//       });
//       if ((await res.json()).success) {
//         setIsModalOpen(false);
//         fetchUpdates();
//       }
//     } catch (err) { console.error(err); }
//   };

//   const handleDeleteEntry = async (id) => {
//     if (!window.confirm("Are you sure you want to remove this schedule notice?")) return;
//     try {
//       const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates/delete-entry/${id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ targetTab: activeTab })
//       });
//       if ((await res.json()).success) fetchUpdates();
//     } catch (err) { console.error(err); }
//   };

// // ➕ ADDED: Pagination Window Range Computation
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(dataList.length / itemsPerPage);


//   return (
//     <div>
//       {/* STEP 1: TOP BRAND ACTION BAR PANEL */}
//      <div style={styles.topActionBar}>
//   <div style={styles.tabScrollGroup}>
//  {/* Update Step 1 tab switch button actions inside the JSX return */}
// <button 
//   onClick={() => { setActiveTab('exams'); setDataList([]); setSearchTerm(''); setCurrentPage(1); }} 
//   style={{ ...styles.tabBtn, ...(activeTab === 'exams' ? styles.tabBtnActive : {}) }}
// >
//   <Calendar size={15} style={{ marginRight: '6px' }} /> Publish Exam Schedules
// </button>
// <button 
//   onClick={() => { setActiveTab('projects'); setDataList([]); setSearchTerm(''); setCurrentPage(1); }} 
//   style={{ ...styles.tabBtn, ...(activeTab === 'projects' ? styles.tabBtnActive : {}) }}
// >
//   <FileText size={15} style={{ marginRight: '6px' }} /> Assign Project Details
// </button>
//   </div>
//         <button onClick={handleOpenAddModal} style={styles.addBtn}>
//           <Plus size={15} style={{ marginRight: '4px' }} /> 
//           {activeTab === 'exams' ? 'Create Exam Timetable' : 'Publish New Project'}
//         </button>
//       </div>

//       {/* STEP 2: SEARCH STRIP FILTERS */}
//       <div style={styles.filterControlPanel}>
//         <div style={styles.searchWrapper}>
//           <Search size={16} style={styles.searchIcon} />
//        {/* Update your search input element */}
// <input 
//   type="text" 
//   placeholder={`Search published bulletins...`} 
//   value={searchTerm} 
//   onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} 
//   style={styles.tableSearchInput} 
// />
//         </div>
//         <div style={styles.totalIndicator}>Active Notices: <strong style={{ color: '#459bf2' }}>{dataList.length}</strong></div>
//       </div>

//       {/* STEP 3: MASTER CLEAN VERTICAL ALIGNED DATA GRID */}
//       {tableLoading ? (
//         <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#459bf2" /></div>
//       ) : (
//         <div style={{ overflowX: 'auto', width: '100%' }}>
//           <table style={styles.dataTable}>
//             {activeTab === 'exams' ? (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Assigned Course Group</th>
//                     <th style={styles.tableTh}>Semester</th>
//                     <th style={styles.tableTh}>Subject Details</th>
//                     <th style={styles.tableTh}>Exam Date & Slot Time</th>
//                     <th style={styles.tableTh}>Assessment Type</th>
//                     <th style={styles.tableTh}>Venue Mode</th>
//                     <th style={styles.tableTh}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="7" style={styles.noDataTd}>No exam timelines published for this selection track.</td></tr>
//                   ) : (
//                     currentItems.map((item) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.target_course}</td>
//                         <td style={styles.tableTd}><span style={styles.termLabel}>{item.current_semester}</span></td>
//                         <td style={styles.tableTd}>
//                           <span style={styles.codeLabel}>{item.subject_code}</span> <strong>{item.subject_name}</strong>
//                         </td>
//                         <td style={styles.tableTd}>
//                           <strong>{new Date(item.exam_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</strong>
//                           <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>Time: {item.exam_time}</div>
//                         </td>
//                         <td style={styles.tableTd}>
//   <span style={item.assessment_type?.includes('End-Semester') ? styles.eseBadge : styles.ciaBadge}>
//     {item.assessment_type || 'N/A'}
//   </span>
// </td>
//                         <td style={styles.tableTd}>{item.exam_mode}</td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit3 size={12} /></button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /></button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             ) : (
//               <>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableTh}>Target Course / Stream</th>
//                     <th style={styles.tableTh}>Semester</th>
//                     <th style={styles.tableTh}>Assigned Project Title</th>
//                     <th style={styles.tableTh}>Problem Statement Scope</th>
//                     <th style={styles.tableTh}>Submission Deadline</th>
//                     <th style={styles.tableTh}>Evaluation Score Caps</th>
//                     <th style={styles.tableTh}>Management Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {dataList.length === 0 ? (
//                     <tr><td colSpan="7" style={styles.noDataTd}>No project definitions uploaded.</td></tr>
//                   ) : (
//                     currentItems.map((item) => (
//                       <tr key={item.id} style={styles.tableTr}>
//                         <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.target_course}</td>
//                         <td style={styles.tableTd}><span style={styles.termLabel}>{item.current_semester}</span></td>
//                         <td style={{ ...styles.tableTd, fontWeight: '600', color: '#0f172a' }}>{item.project_title}</td>
//                         <td style={{ ...styles.tableTd, whiteSpace: 'normal', maxWidth: '240px', fontSize: '12px', color: '#64748b' }}>
//                           {item.problem_statement}
//                           {item.reference_link && (
//                             <div style={{ marginTop: '6px' }}>
//                               <a href={item.reference_link} target="_blank" rel="noreferrer" style={styles.linkAnchor}><Link size={11} /> View cloud materials</a>
//                             </div>
//                           )}
//                         </td>
//                         <td style={{ ...styles.tableTd, color: '#a80302', fontWeight: '700' }}>
//                           {new Date(item.submission_deadline).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//                         </td>
//                         <td style={styles.tableTd}>
//                           <span style={styles.marksBadge}><Award size={12} /> {item.max_marks} Max Marks</span>
//                         </td>
//                         <td style={styles.tableTd}>
//                           <div style={styles.actionBtnGroup}>
//                             <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn}><Edit3 size={12} /></button>
//                             <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn}><Trash2 size={12} /></button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </>
//             )}
//           </table>
//         </div>
//       )}


//       {/* ➕ ADDED: PREMIUM PAGINATION TOOLBAR */}
//       {dataList.length > 0 && (
//         <div style={styles.paginationDock}>
//           <button 
//             disabled={currentPage === 1} 
//             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//             style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Previous
//           </button>
//           <span style={styles.pageIndicator}>
//             Page <strong>{currentPage}</strong> of {totalPages || 1}
//           </span>
//           <button 
//             disabled={currentPage === totalPages || totalPages === 0} 
//             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//             style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* DYNAMIC SMART FORM POPUP MODAL CONTROL WINDOW */}
//       {isModalOpen && (
//         <div style={styles.modalBackdrop}>
//           <div style={styles.modalWrapperCard}>
//             <div style={styles.modalHeader}>
//               <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
//                 {editingId ? 'Modify Published Bulletin details' : 'Publish New Academic Directive Notice'}
//               </h3>
//               <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
//             </div>
//             <form onSubmit={handleFormSubmit} style={styles.modalForm}>
              
//               {/* SHARED GROUP SCOPE CHASSIS PARAMETERS */}
//               {/* <div style={styles.formSplitGrid}>
//                 <div style={styles.fieldContainer}>
//                   <label style={styles.fieldLabel}>Target Course Stream</label>
//                   <select value={activeTab === 'exams' ? examForm.target_course : projectForm.target_course} onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, target_course: e.target.value }) : setProjectForm({ ...projectForm, target_course: e.target.value })} style={styles.formSelect}>
//                     <option>React FullStack</option><option>Data Science & AI</option><option>Cyber Security Master</option><option>B.B.A.</option><option>M.C.A.</option>
//                   </select>
//                 </div>
//                 <div style={styles.formSplitGrid}>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Semester Group</label>
//                     <select value={activeTab === 'exams' ? examForm.current_semester : projectForm.current_semester} onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, current_semester: e.target.value }) : setProjectForm({ ...projectForm, current_semester: e.target.value })} style={styles.formSelect}>
//                       <option>Semester 1</option><option>Semester 2</option><option>Semester 3</option><option>Semester 4</option>
//                     </select>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Academic Year</label>
//                     <input type="text" required placeholder="e.g. 2026-2027" value={activeTab === 'exams' ? examForm.academic_year : projectForm.academic_year} onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, academic_year: e.target.value }) : setProjectForm({ ...projectForm, academic_year: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </div>
//               </div> */}


// <div style={styles.formSplitGrid}>
//   <div style={styles.fieldContainer}>
//     <label style={styles.fieldLabel}>Target Course Stream</label>
//     <select 
//       value={activeTab === 'exams' ? examForm.target_course : projectForm.target_course} 
//       onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, target_course: e.target.value }) : setProjectForm({ ...projectForm, target_course: e.target.value })} 
//       style={styles.formSelect}
//     >
//       {coursesList.length === 0 ? (
//         <option value="">Loading courses...</option>
//       ) : (
//         coursesList.map((course) => (
//           <option key={course.id} value={course.course_name.trim()}>
//             {course.course_name.trim()}
//           </option>
//         ))
//       )}
//     </select>
//   </div>
//   <div style={styles.formSplitGrid}>
//     <div style={styles.fieldContainer}>
//       <label style={styles.fieldLabel}>Semester Group</label>
//       <select 
//         value={activeTab === 'exams' ? examForm.current_semester : projectForm.current_semester} 
//         onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, current_semester: e.target.value }) : setProjectForm({ ...projectForm, current_semester: e.target.value })} 
//         style={styles.formSelect}
//       >
//         <option>Semester 1</option>
//         <option>Semester 2</option>
//         <option>Semester 3</option>
//         <option>Semester 4</option>
//         <option>Semester 5</option>
//         <option>Semester 6</option>
//       </select>
//     </div>
//     <div style={styles.fieldContainer}>
//       <label style={styles.fieldLabel}>Academic Year</label>
//       <input type="text" required placeholder="e.g. 2026-2027" value={activeTab === 'exams' ? examForm.academic_year : projectForm.academic_year} onChange={(e) => activeTab === 'exams' ? setExamForm({ ...examForm, academic_year: e.target.value }) : setProjectForm({ ...projectForm, academic_year: e.target.value })} style={styles.formInput} />
//     </div>
//   </div>
// </div>
//               {/* CONTEXT FIELDS A: EXAM FORMS SUBSET */}
//               {activeTab === 'exams' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Subject / Paper Code</label>
//                       <input type="text" required placeholder="e.g. CS-315" value={examForm.subject_code} onChange={(e) => setExamForm({ ...examForm, subject_code: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Subject Paper Name</label>
//                       <input type="text" required placeholder="e.g. Discrete Mathematics" value={examForm.subject_name} onChange={(e) => setExamForm({ ...examForm, subject_name: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Examination Date</label>
//                       <input type="date" required value={examForm.exam_date} onChange={(e) => setExamForm({ ...examForm, exam_date: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Slotted Time Schedule</label>
//                       <input type="text" required placeholder="e.g. 10:00 AM - 01:00 PM" value={examForm.exam_time} onChange={(e) => setExamForm({ ...examForm, exam_time: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Assessment Scheme Evaluation Category</label>
//                       <select value={examForm.assessment_type} onChange={(e) => setExamForm({ ...examForm, assessment_type: e.target.value })} style={styles.formSelect}>
//                         <option>End-Semester Exam (ESE)</option><option>Continuous Internal Assessment (CIA)</option>
//                       </select>
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Delivery Examination Venue Mode</label>
//                       <select value={examForm.exam_mode} onChange={(e) => setExamForm({ ...examForm, exam_mode: e.target.value })} style={styles.formSelect}>
//                         <option>Online Testing Portal</option><option>Main Campus Center HQ</option><option>Affiliated Regional College Desk</option>
//                       </select>
//                     </div>
//                   </div>
//                 </>
//               )}

//               {/* CONTEXT FIELDS B: ACADEMIC PROJECT SUBSET */}
//               {activeTab === 'projects' && (
//                 <>
//                   <div style={styles.formSplitGrid}>
//                     <div style={styles.fieldContainer} style={{ flex: 1 }}>
//                       <label style={styles.fieldLabel}>Project Track Title Name</label>
//                       <input type="text" required placeholder="e.g. Hospital Management System Architecture Setup" value={projectForm.project_title} onChange={(e) => setProjectForm({ ...projectForm, project_title: e.target.value })} style={styles.formInput} />
//                     </div>
//                     <div style={styles.fieldContainer}>
//                       <label style={styles.fieldLabel}>Maximum Attainable Evaluation Score Marks</label>
//                       <input type="number" required placeholder="100" value={projectForm.max_marks} onChange={(e) => setProjectForm({ ...projectForm, max_marks: e.target.value })} style={styles.formInput} />
//                     </div>
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Problem Statement Guidelines / Submission Instructions Scope</label>
//                     <textarea required rows="3" placeholder="Enter instructions details here..." value={projectForm.problem_statement} onChange={(e) => setProjectForm({ ...projectForm, problem_statement: e.target.value })} style={styles.formTextArea} />
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Submission Deadline Target Picker</label>
//                     <input type="date" required value={projectForm.submission_deadline} onChange={(e) => setProjectForm({ ...projectForm, submission_deadline: e.target.value })} style={styles.formInput} />
//                   </div>
//                   <div style={styles.fieldContainer}>
//                     <label style={styles.fieldLabel}>Materials Reference Folder Link (Cloud URI Anchor - Optional)</label>
//                     <input type="url" placeholder="https://drive.google.com/..." value={projectForm.reference_link} onChange={(e) => setProjectForm({ ...projectForm, reference_link: e.target.value })} style={styles.formInput} />
//                   </div>
//                 </>
//               )}

//               <div style={styles.formActionDock}>
//                 <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
//                 <button type="submit" style={styles.formSaveBtn}>Submit</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // LUXURIOUS CORPORATE HOVER MAP PARAMETERS CHASSIS
// const styles = {
//   topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
//   tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
//   tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
//   tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
//   addBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
//   filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
//   searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '300px', width: '100%' },
//   searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
//   tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
//   totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
//   dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
//   tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
//   tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
//   tableTd: { padding: '14px 14px', color: '#475569', fontSize: '13.5px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
//   noDataTd: { padding: '36px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
//   termLabel: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '3px 6px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
//   codeLabel: { background: '#f1f5f9', color: '#475569', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontFamily: 'monospace', fontWeight: '700', marginRight: '6px', border: '1px solid #cbd5e1' },
//   ciaBadge: { background: '#fffbeb', border: '1px solid #fde68a', color: '#b45309', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
//   eseBadge: { background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
//   marksBadge: { background: '#f5f3ff', border: '1px solid #ddd6fe', color: '#6d28d9', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '4px' },
//   linkAnchor: { color: '#1c6ec9', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '3px', fontWeight: '600', fontSize: '12px' },
//   actionBtnGroup: { display: 'flex', gap: '6px' },
//   editRowBtn: { background: '#ffffff', border: '1px solid #cbd5e1', color: '#475569', padding: '6px', borderRadius: '6px', cursor: 'pointer' },
//   deleteRowBtn: { background: '#ffffff', border: '1px solid #fecaca', color: '#b91c1c', padding: '6px', borderRadius: '6px', cursor: 'pointer' },
//   modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
//   modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '600px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
//   modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
//   modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
//   modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px', overflowY: 'auto' },
//   formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
//   fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
//   fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
//   formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
//   formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
//   formTextArea: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' },
//   formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
//   formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
//  // Append these design properties inside your styles object matrix
//   paginationDock: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #edf2f7'
//   },
//   pageIndicator: {
//     fontSize: '13px',
//     color: '#475569'
//   },
//   pageBtn: {
//     background: '#ffffff',
//     border: '1px solid #e2e8f0',
//     borderRadius: '6px',
//     padding: '6px 14px',
//     color: '#334155',
//     fontSize: '12.5px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s'
//   },
//   pageBtnDisabled: {
//     background: '#f8fafc',
//     color: '#94a3b8',
//     cursor: 'not-allowed',
//     borderColor: '#e2e8f0'
//   },
 
//   formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
// };


import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Search, Calendar, FileText, Plus, X, Loader2, Edit3, Trash2, Paperclip, ExternalLink, Ticket, Award, Download } from 'lucide-react';

export default function ExamProjectUpdates() {
  const [activeTab, setActiveTab] = useState('exams'); // exams, projects, halltickets, results
  const [dataList, setDataList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableLoading, setTableLoading] = useState(false);

  // Dynamic Course Cascades & Term Options
  const [courseCascades, setCourseCascades] = useState([]);
  const [availableTerms, setAvailableTerms] = useState([]);

  // Modal Controls
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  // Pagination Parameters
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Unified Form State
  const [formData, setFormData] = useState({
    program_type: 'Under-Graduate (UG)',
    target_course: '',
    current_semester: '',
    academic_year: '2026-2027',
    reference_link: '',
    file_attachment_url: ''
  });

  const tabOptions = [
    { id: 'exams', label: 'Exam Schedules', icon: Calendar },
    { id: 'projects', label: 'Projects & Assignments', icon: FileText },
    { id: 'halltickets', label: 'Exam Hall Tickets', icon: Ticket },
    { id: 'results', label: 'Exam Results', icon: Award }
  ];

// ➕ Dynamic Excel Export for all active tabs
const handleExportToExcel = () => {
  if (dataList.length === 0) {
    alert(`No records available to export for ${getTabTitle()}.`);
    return;
  }

  const exportData = dataList.map((item, index) => {
    if (activeTab === 'projects') {
      return {
        "S.No": index + 1,
        "Record ID": `#${item.id}`,
        "Course Track": item.target_course || 'N/A',
        "Term / Semester": item.current_semester || 'N/A',
        "Academic Year": item.academic_year || 'N/A',
        "Document Attachment": item.file_attachment_url || 'None',
        "Reference URL": item.reference_link || 'None',
        "Uploaded Date": item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'
      };
    } else {
      return {
        "S.No": index + 1,
        "Record ID": `#${item.id}`,
        "Program Classification": item.program_type || item.target_course || 'Under-Graduate (UG)',
        "Academic Year": item.academic_year || 'N/A',
        "Document Attachment": item.file_attachment_url || 'None',
        "Reference URL": item.reference_link || 'None',
        "Uploaded Date": item.created_at ? new Date(item.created_at).toLocaleDateString('en-IN') : 'N/A'
      };
    }
  });

  const sheetName = getTabTitle().replace(/[^a-zA-Z0-9]/g, '_').substring(0, 31);
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const fileName = `${sheetName}_Report_${new Date().toISOString().substring(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};


  const programTypeOptions = [
  "Under-Graduate (UG)",
  "Post-Graduate (PG)",
  "Diploma",
  "Certificate",
  "Secondary (10th)",
  "Higher Secondary (12th)",
  "PG Diploma"
];

  useEffect(() => {
    fetchUpdates();
  }, [activeTab, searchTerm]);

  useEffect(() => {
    fetchCourseCascades();
  }, []);

  const fetchUpdates = async () => {
    setTableLoading(true);
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates?activeTab=${activeTab}&search=${encodeURIComponent(searchTerm)}`);
      const result = await res.json();
      if (result.success) setDataList(result.data);
      else setDataList([]);
    } catch (err) {
      console.error(err);
      setDataList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const fetchCourseCascades = async () => {
    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/academic-updates/course-cascades');
      const result = await res.json();
      if (result.success && result.data.length > 0) {
        setCourseCascades(result.data);
      }
    } catch (err) {
      console.error("Failed to load course options:", err);
    }
  };

  // 🔄 Dynamic term generator based on Course selection
  const handleCourseSelectionChange = (courseName) => {
    const selected = courseCascades.find(c => c.course_name.trim() === courseName.trim());
    let terms = [];

    if (selected) {
      if (selected.semester_details && selected.semester_details.length > 0) {
        terms = selected.semester_details.map(s => s.term_label);
      } else if (selected.syllabus_structure && selected.syllabus_structure.length > 0) {
        terms = selected.syllabus_structure.map(s => s.term);
      } else {
        const total = selected.structure_type === 'Semester' ? (selected.minimum_duration || 3) * 2 : (selected.minimum_duration || 1);
        for (let i = 1; i <= total; i++) {
          terms.push(selected.structure_type === 'Semester' ? `Semester ${i}` : `Year ${i}`);
        }
      }
    }

    setAvailableTerms(terms);
    setFormData(prev => ({
      ...prev,
      target_course: courseName,
      current_semester: terms[0] || ''
    }));
  };

  // const handleOpenAddModal = () => {
  //   setEditingId(null);
  //   setUploadFile(null);

  //   const firstCourse = courseCascades[0]?.course_name.trim() || '';
  //   handleCourseSelectionChange(firstCourse);

  //   setFormData({
  //     target_course: firstCourse,
  //     current_semester: '',
  //     academic_year: '2026-2027',
  //     reference_link: '',
  //     file_attachment_url: ''
  //   });

  //   setIsModalOpen(true);
  // };

  // const handleOpenEditModal = (item) => {
  //   setEditingId(item.id);
  //   setUploadFile(null);

  //   const selected = courseCascades.find(c => c.course_name.trim() === item.target_course.trim());
  //   let terms = [];
  //   if (selected) {
  //     if (selected.semester_details && selected.semester_details.length > 0) {
  //       terms = selected.semester_details.map(s => s.term_label);
  //     } else if (selected.syllabus_structure && selected.syllabus_structure.length > 0) {
  //       terms = selected.syllabus_structure.map(s => s.term);
  //     }
  //   }
  //   setAvailableTerms(terms);

  //   setFormData({
  //     target_course: item.target_course || '',
  //     current_semester: item.current_semester || '',
  //     academic_year: item.academic_year || '2026-2027',
  //     reference_link: item.reference_link || '',
  //     file_attachment_url: item.file_attachment_url || ''
  //   });

  //   setIsModalOpen(true);
  // };



const handleOpenAddModal = () => {
  setEditingId(null);
  setUploadFile(null);

  const firstCourse = courseCascades[0]?.course_name.trim() || '';
  handleCourseSelectionChange(firstCourse);

  setFormData({
    program_type: 'Under-Graduate (UG)',
    target_course: firstCourse,
    current_semester: '',
    academic_year: '2026-2027',
    reference_link: '',
    file_attachment_url: ''
  });

  setIsModalOpen(true);
};

const handleOpenEditModal = (item) => {
  setEditingId(item.id);
  setUploadFile(null);

  if (activeTab === 'projects') {
    const selected = courseCascades.find(c => c.course_name.trim() === (item.target_course || '').trim());
    let terms = [];
    if (selected) {
      if (selected.semester_details && selected.semester_details.length > 0) {
        terms = selected.semester_details.map(s => s.term_label);
      } else if (selected.syllabus_structure && selected.syllabus_structure.length > 0) {
        terms = selected.syllabus_structure.map(s => s.term);
      }
    }
    setAvailableTerms(terms);
  }

  setFormData({
    program_type: item.program_type || 'Under-Graduate (UG)',
    target_course: item.target_course || '',
    current_semester: item.current_semester || '',
    academic_year: item.academic_year || '2026-2027',
    reference_link: item.reference_link || '',
    file_attachment_url: item.file_attachment_url || ''
  });

  setIsModalOpen(true);
};


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const payloadFormData = new FormData();
    payloadFormData.append('targetTab', activeTab);
    payloadFormData.append('payload', JSON.stringify(formData));
    if (uploadFile) {
      payloadFormData.append('file_attachment', uploadFile);
    }

    const endpoint = editingId ? `update-entry/${editingId}` : 'add-entry';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates/${endpoint}`, {
        method: method,
        body: payloadFormData
      });
      const result = await res.json();
      if (result.success) {
        setIsModalOpen(false);
        fetchUpdates();
      } else {
        alert(result.message || "Operation failed.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteEntry = async (id) => {
    if (!window.confirm("Are you sure you want to remove this record?")) return;
    try {
      const res = await fetch(`https://metapi.emedhatechnologies.com/api/academic-updates/delete-entry/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ targetTab: activeTab })
      });
      if ((await res.json()).success) fetchUpdates();
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination Window Range Computation
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(dataList.length / itemsPerPage);

  const getTabTitle = () => {
    const current = tabOptions.find(t => t.id === activeTab);
    return current ? current.label : 'Directive';
  };

  return (
    <div style={styles.container}>
      
      {/* STEP 1: TOP NAVIGATION TABS */}
      <div style={styles.topActionBar}>
        <div style={styles.tabScrollGroup}>
          {tabOptions.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => { setActiveTab(tab.id); setDataList([]); setSearchTerm(''); setCurrentPage(1); }}
                style={{ ...styles.tabBtn, ...(isActive ? styles.tabBtnActive : {}) }}
              >
                <Icon size={15} style={{ marginRight: '6px' }} /> {tab.label}
              </button>
            );
          })}
        </div>
        <button onClick={handleOpenAddModal} style={styles.addBtn}>
          <Plus size={15} style={{ marginRight: '4px' }} /> Add {getTabTitle()}
        </button>
      </div>

      {/* STEP 2: SEARCH FILTER BAR */}
  {/* STEP 2: SEARCH FILTER BAR */}
<div style={styles.filterControlPanel}>
  <div style={styles.searchWrapper}>
    <Search size={16} style={styles.searchIcon} />
    <input
      type="text"
      placeholder={`Search ${getTabTitle()} by course, term, or academic year...`}
      value={searchTerm}
      onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
      style={styles.tableSearchInput}
    />
  </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <button
      type="button"
      onClick={handleExportToExcel}
      style={styles.exportExcelBtn}
      title={`Export all ${getTabTitle()} to Excel`}
    >
      <Download size={14} /> Download Excel
    </button>

    <div style={styles.totalIndicator}>
      Active Records: <strong style={{ color: '#1c6ec9' }}>{dataList.length}</strong>
    </div>
  </div>
</div>

      {/* STEP 3: UNIFIED DATA TABLE */}
      {tableLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
          <Loader2 size={32} style={{ animation: 'spin 1s linear infinite' }} color="#1c6ec9" />
        </div>
      ) : (
        <div style={{ overflowX: 'auto', width: '100%' }}>
          {/* <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Course Track</th>
                <th style={styles.tableTh}>Term / Semester</th>
                <th style={styles.tableTh}>Academic Year</th>
                <th style={styles.tableTh}>Document Attachment</th>
                <th style={styles.tableTh}>Reference URL</th>
                <th style={styles.tableTh}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dataList.length === 0 ? (
                <tr><td colSpan="6" style={styles.noDataTd}>No records uploaded yet for {getTabTitle()}.</td></tr>
              ) : (
                currentItems.map((item) => (
                  <tr key={item.id} style={styles.tableTr}>
                    <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.target_course}</td>
                    <td style={styles.tableTd}><span style={styles.termLabel}>{item.current_semester}</span></td>
                    <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.academic_year}</td>
                    <td style={styles.tableTd}>
                      {item.file_attachment_url ? (
                        <a href={item.file_attachment_url} target="_blank" rel="noreferrer" style={styles.fileAnchor}>
                          <Paperclip size={12} style={{ marginRight: '4px' }} /> View Document
                        </a>
                      ) : (
                        <span style={{ color: '#94a3b8', fontSize: '12px' }}>No File</span>
                      )}
                    </td>
                    <td style={styles.tableTd}>
                      {item.reference_link ? (
                        <a href={item.reference_link} target="_blank" rel="noreferrer" style={styles.linkAnchor}>
                          <ExternalLink size={12} style={{ marginRight: '4px' }} /> Open Link
                        </a>
                      ) : (
                        <span style={{ color: '#94a3b8', fontSize: '12px' }}>None</span>
                      )}
                    </td>
                    <td style={styles.tableTd}>
                      <div style={styles.actionBtnGroup}>
                        <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn} title="Edit"><Edit3 size={12} /></button>
                        <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn} title="Delete"><Trash2 size={12} /></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table> */}
          <table style={styles.dataTable}>
  <thead>
    <tr>
      {activeTab === 'projects' ? (
        <>
          <th style={styles.tableTh}>Course Track</th>
          <th style={styles.tableTh}>Term / Semester</th>
        </>
      ) : (
        <th style={styles.tableTh}>Program Classification</th>
      )}
      <th style={styles.tableTh}>Academic Year</th>
      <th style={styles.tableTh}>Document Attachment</th>
      <th style={styles.tableTh}>Reference URL</th>
      <th style={styles.tableTh}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {dataList.length === 0 ? (
      <tr>
        <td colSpan={activeTab === 'projects' ? "6" : "5"} style={styles.noDataTd}>
          No records uploaded yet for {getTabTitle()}.
        </td>
      </tr>
    ) : (
      currentItems.map((item) => (
        <tr key={item.id} style={styles.tableTr}>
          {activeTab === 'projects' ? (
            <>
              <td style={{ ...styles.tableTd, fontWeight: '700', color: '#1c6ec9' }}>{item.target_course}</td>
              <td style={styles.tableTd}><span style={styles.termLabel}>{item.current_semester}</span></td>
            </>
          ) : (
            <td style={{ ...styles.tableTd, fontWeight: '700', color: '#0f172a' }}>
              <span style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight: '700' }}>
                {item.program_type || item.target_course || 'Under-Graduate (UG)'}
              </span>
            </td>
          )}

          <td style={{ ...styles.tableTd, fontWeight: '600' }}>{item.academic_year}</td>
          
          <td style={styles.tableTd}>
            {item.file_attachment_url ? (
              <a href={item.file_attachment_url} target="_blank" rel="noreferrer" style={styles.fileAnchor}>
                <Paperclip size={12} style={{ marginRight: '4px' }} /> View Document
              </a>
            ) : (
              <span style={{ color: '#94a3b8', fontSize: '12px' }}>No File</span>
            )}
          </td>

          <td style={styles.tableTd}>
            {item.reference_link ? (
              <a href={item.reference_link} target="_blank" rel="noreferrer" style={styles.linkAnchor}>
                <ExternalLink size={12} style={{ marginRight: '4px' }} /> Open Link
              </a>
            ) : (
              <span style={{ color: '#94a3b8', fontSize: '12px' }}>None</span>
            )}
          </td>

          <td style={styles.tableTd}>
            <div style={styles.actionBtnGroup}>
              <button onClick={() => handleOpenEditModal(item)} style={styles.editRowBtn} title="Edit"><Edit3 size={12} /></button>
              <button onClick={() => handleDeleteEntry(item.id)} style={styles.deleteRowBtn} title="Delete"><Trash2 size={12} /></button>
            </div>
          </td>
        </tr>
      ))
    )}
  </tbody>
</table>
        </div>
      )}

      {/* STEP 4: PAGINATION */}
      {dataList.length > 0 && (
        <div style={styles.paginationDock}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            style={currentPage === 1 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Previous
          </button>
          <span style={styles.pageIndicator}>
            Page <strong>{currentPage}</strong> of {totalPages || 1}
          </span>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            style={currentPage === totalPages || totalPages === 0 ? { ...styles.pageBtn, ...styles.pageBtnDisabled } : styles.pageBtn}
          >
            Next
          </button>
        </div>
      )}

      {/* STEP 5: SIMPLIFIED MODAL POPUP WINDOW */}
      {isModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalWrapperCard}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                {editingId ? `Modify ${getTabTitle()}` : `Add New ${getTabTitle()}`}
              </h3>
              <button onClick={() => setIsModalOpen(false)} style={styles.modalCloseX}><X size={18} /></button>
            </div>

            {/* <form onSubmit={handleFormSubmit} style={styles.modalForm}>
              
            
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Select Course Stream *</label>
                <select
                  required
                  value={formData.target_course}
                  onChange={(e) => handleCourseSelectionChange(e.target.value)}
                  style={styles.formSelect}
                >
                  <option value="">-- Choose Course Stream --</option>
                  {courseCascades.map((course) => (
                    <option key={course.id} value={course.course_name.trim()}>
                      {course.course_code} - {course.course_name.trim()} ({course.structure_type})
                    </option>
                  ))}
                </select>
              </div>

             
              <div style={styles.formSplitGrid}>
                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Term / Semester *</label>
                  <select
                    required
                    value={formData.current_semester}
                    onChange={(e) => setFormData({ ...formData, current_semester: e.target.value })}
                    style={styles.formSelect}
                  >
                    <option value="">-- Select Term --</option>
                    {availableTerms.map((term, idx) => (
                      <option key={idx} value={term}>{term}</option>
                    ))}
                  </select>
                </div>

                <div style={styles.fieldContainer}>
                  <label style={styles.fieldLabel}>Academic Year *</label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. 2026-2027"
                    value={formData.academic_year}
                    onChange={(e) => setFormData({ ...formData, academic_year: e.target.value })}
                    style={styles.formInput}
                  />
                </div>
              </div>

           
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Upload Document (PDF, Excel, Images, Word - Optional)</label>
                <input
                  type="file"
                  accept=".pdf,.png,.jpg,.jpeg,.xlsx,.xls,.docx,.doc"
                  onChange={(e) => setUploadFile(e.target.files[0])}
                  style={styles.formFileInput}
                />
              </div>

             
              <div style={styles.fieldContainer}>
                <label style={styles.fieldLabel}>Reference URL / Online Link (Optional)</label>
                <input
                  type="url"
                  placeholder="https://drive.google.com/... or result portal link"
                  value={formData.reference_link}
                  onChange={(e) => setFormData({ ...formData, reference_link: e.target.value })}
                  style={styles.formInput}
                />
              </div>

              <div style={styles.formActionDock}>
                <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
                <button type="submit" style={styles.formSaveBtn}>Save Directive</button>
              </div>

            </form> */}
            <form onSubmit={handleFormSubmit} style={styles.modalForm}>
  
  {/* A. If tab is 'projects', keep Course Stream + Term / Semester */}
  {activeTab === 'projects' ? (
    <>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Select Course Stream *</label>
        <select
          required
          value={formData.target_course}
          onChange={(e) => handleCourseSelectionChange(e.target.value)}
          style={styles.formSelect}
        >
          <option value="">-- Choose Course Stream --</option>
          {courseCascades.map((course) => (
            <option key={course.id} value={course.course_name.trim()}>
              {course.course_code} - {course.course_name.trim()} ({course.structure_type})
            </option>
          ))}
        </select>
      </div>

      <div style={styles.formSplitGrid}>
        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Term / Semester *</label>
          <select
            required
            value={formData.current_semester}
            onChange={(e) => setFormData({ ...formData, current_semester: e.target.value })}
            style={styles.formSelect}
          >
            <option value="">-- Select Term --</option>
            {availableTerms.map((term, idx) => (
              <option key={idx} value={term}>{term}</option>
            ))}
          </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.fieldLabel}>Academic Year *</label>
          <input
            type="text"
            required
            placeholder="e.g. 2026-2027"
            value={formData.academic_year}
            onChange={(e) => setFormData({ ...formData, academic_year: e.target.value })}
            style={styles.formInput}
          />
        </div>
      </div>
    </>
  ) : (
    /* B. For Exams, Halltickets, and Results: Program Type + Academic Year */
    <div style={styles.formSplitGrid}>
      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Program Classification *</label>
        <select
          required
          value={formData.program_type}
          onChange={(e) => setFormData({ ...formData, program_type: e.target.value })}
          style={styles.formSelect}
        >
          {programTypeOptions.map((prog, idx) => (
            <option key={idx} value={prog}>{prog}</option>
          ))}
        </select>
      </div>

      <div style={styles.fieldContainer}>
        <label style={styles.fieldLabel}>Academic Year *</label>
        <input
          type="text"
          required
          placeholder="e.g. 2026-2027"
          value={formData.academic_year}
          onChange={(e) => setFormData({ ...formData, academic_year: e.target.value })}
          style={styles.formInput}
        />
      </div>
    </div>
  )}

  {/* Document Attachment Upload (Common for all tabs) */}
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Upload Document (PDF, Excel, Images, Word - Optional)</label>
    <input
      type="file"
      accept=".pdf,.png,.jpg,.jpeg,.xlsx,.xls,.docx,.doc"
      onChange={(e) => setUploadFile(e.target.files[0])}
      style={styles.formFileInput}
    />
  </div>

  {/* Cloud URL / Reference Link (Common for all tabs) */}
  <div style={styles.fieldContainer}>
    <label style={styles.fieldLabel}>Reference URL / Online Link (Optional)</label>
    <input
      type="url"
      placeholder="https://drive.google.com/... or result portal link"
      value={formData.reference_link}
      onChange={(e) => setFormData({ ...formData, reference_link: e.target.value })}
      style={styles.formInput}
    />
  </div>

  <div style={styles.formActionDock}>
    <button type="button" onClick={() => setIsModalOpen(false)} style={styles.formCancelBtn}>Cancel</button>
    <button type="submit" style={styles.formSaveBtn}>Save Directive</button>
  </div>

</form>
          </div>
        </div>
      )}

    </div>
  );
}

// STYLES MATRIX
const styles = {
  container: { width: '100%', boxSizing: 'border-box' },
  topActionBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' },
  tabScrollGroup: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
  tabBtn: { display: 'inline-flex', alignItems: 'center', padding: '10px 16px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontSize: '13.5px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' },
  tabBtnActive: { background: 'linear-gradient(135deg, #459bf2 0%, #1c6ec9 100%)', borderColor: '#459bf2', color: '#ffffff', boxShadow: '0 4px 12px rgba(69, 155, 242, 0.15)' },
  addBtn: { background: 'linear-gradient(90deg, #e30504 0%, #a80302 100%)', border: 'none', borderRadius: '12px', color: '#fff', padding: '12px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' },
  filterControlPanel: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap', borderBottom: '1px solid #edf2f7', paddingBottom: '14px' },
  searchWrapper: { position: 'relative', display: 'flex', alignItems: 'center', flex: 1, maxWidth: '340px', width: '100%' },
  searchIcon: { position: 'absolute', left: '12px', color: '#94a3b8' },
  tableSearchInput: { width: '100%', padding: '9px 12px 9px 36px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '9px', color: '#0f172a', fontSize: '13.5px', outline: 'none' },
  totalIndicator: { fontSize: '14.5px', fontWeight: '600', color: '#334155' },
  dataTable: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  tableTh: { padding: '12px 14px', borderBottom: '2px solid #e2e8f0', color: '#64748b', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600', whiteSpace: 'nowrap' },
  tableTr: { borderBottom: '1px solid #f1f5f9', background: '#ffffff' },
  tableTd: { padding: '14px 14px', color: '#475569', fontSize: '13.5px', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  noDataTd: { padding: '36px 14px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', fontWeight: '500' },
  termLabel: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', padding: '3px 8px', borderRadius: '5px', fontSize: '11.5px', fontWeight: '600' },
  fileAnchor: { display: 'inline-flex', alignItems: 'center', background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1c6ec9', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', textDecoration: 'none' },
  linkAnchor: { display: 'inline-flex', alignItems: 'center', background: '#f8fafc', border: '1px solid #cbd5e1', color: '#334155', padding: '4px 8px', borderRadius: '6px', fontSize: '11.5px', fontWeight: '600', textDecoration: 'none' },
  actionBtnGroup: { display: 'flex', gap: '6px' },
  exportExcelBtn: {
  background: '#0f172a',
  color: '#ffffff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: '8px',
  fontSize: '12.5px',
  fontWeight: '700',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  boxShadow: '0 2px 4px rgba(15, 23, 42, 0.1)',
  transition: 'all 0.2s ease',
  whiteSpace: 'nowrap'
},
  editRowBtn: { background: '#ffffff', border: '1px solid #cbd5e1', color: '#475569', padding: '6px', borderRadius: '6px', cursor: 'pointer' },
  deleteRowBtn: { background: '#ffffff', border: '1px solid #fecaca', color: '#b91c1c', padding: '6px', borderRadius: '6px', cursor: 'pointer' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.25)', backdropFilter: 'blur(8px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  modalWrapperCard: { background: '#ffffff', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '20px', width: '100%', maxWidth: '540px', maxHeight: '85vh', padding: '24px', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' },
  modalCloseX: { background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' },
  modalForm: { display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px', overflowY: 'auto' },
  formSplitGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  fieldContainer: { display: 'flex', flexDirection: 'column', gap: '4px' },
  fieldLabel: { color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  formInput: { width: '100%', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none', boxSizing: 'border-box' },
  formSelect: { padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#0f172a', fontSize: '13px', outline: 'none' },
  formFileInput: { fontSize: '12px', color: '#475569', padding: '6px 0' },
  formActionDock: { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '12px' },
  formCancelBtn: { background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '9px 16px', borderRadius: '8px', cursor: 'pointer' },
  paginationDock: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #edf2f7' },
  pageIndicator: { fontSize: '13px', color: '#475569' },
  pageBtn: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '6px 14px', color: '#334155', fontSize: '12.5px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' },
  pageBtnDisabled: { background: '#f8fafc', color: '#94a3b8', cursor: 'not-allowed', borderColor: '#e2e8f0' },
  formSaveBtn: { background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)', border: 'none', color: '#fff', padding: '9px 16px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }
};